<template>
    <Modal
      :show.sync="isOpen"
      :on-close="onClose"
    >
        <div ref="disableFieldsContainerRefs" class="px_32 py_32 aiBroadcastPreview">
            <div class="mb_24">
                <h2 class="font_regular font_600 text_20">{{$t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.PREVIEW_MODAL.TITLE')}}</h2>
            </div>
            <!-- step 1: kind  -->
            <!--
                <section>
                <ul class="campaign_types">
                    <li v-for="item in types" class="campaign_type" :class="kind===item.value ? 'active_type':''" :key="item.title">
                        <div class="type_icon">
                            <div v-html="item.icon"></div>
                        </div>
                        <div class="type_body">
                            <h3 class="name">{{item.title}}</h3>
                            <p class="description">{{item.description}}</p>
                        </div>
                    </li>
                </ul>
            </section>
            -->
            <section>
                <!-- Audience filter logic -->
                <article>
                    <section>
                        <label class="field_label" >{{ $t('CAMPAIGN.ADD_STEP.ONE_OFF.AUDIENCE_LABEL') }}</label>
                        <div class="medium-12 columns audience_filter" v-if="appliedFilters.length">
                            <filter-input-box
                            v-for="(filter, i) in appliedFilters"
                            :key="i"
                            v-model="appliedFilters[i]"
                            :filter-groups="filterGroups"
                            :grouped-filters="true"
                            :input-type="getInputType(appliedFilters[i].attribute_key)"
                            :operators="getOperators(appliedFilters[i].attribute_key)"
                            :dropdown-values="getDropdownValues(appliedFilters[i].attribute_key)"
                            :show-query-operator="i !== appliedFilters.length - 1"
                            :show-user-input="showUserInput(appliedFilters[i].filter_operator)"
                            :v="$v.appliedFilters.$each[i]"
                            reOrderLabels = "false"
                            :disableAll="true"
                            />
                        </div>
                    </section>
                </article>

                 <!-- days type filter group kind=repeat -->
                <section v-if="kind === 'repeat'">
                    <label :class="{ error: $v.appliedFilters.$error }">
                        {{ $t('CAMPAIGN.ADD.FORM.AUDIENCE.CUSTOM_LABEL') }}
                    </label>
                    <div class="medium-12 columns audience_filter">
                        <filter-input-box
                            v-for="(filter, i) in [appliedFilters[0]]"
                            :key="i"
                            v-model="campaign_repeat_at"
                            :filter-groups="onGoingDateFilterGroups"
                            :grouped-filters="true"
                            input-type=""
                            :operators="onGoingOperators"
                            :dropdown-values="getDropdownValues(appliedFilters[i].attribute_key)"
                            :show-query-operator="false"
                            :show-user-input="showUserInput(appliedFilters[i].filter_operator) ? true:true"
                            :v="$v.appliedFilters.$each[i]"
                            reOrderLabels = "true"
                            :disableAll="true"
                        />
                    </div>
                </section>

                <!-- schedule time Day selector when type=repeat  -->
                <label v-if="kind === 'repeat'" class="add_camp_calendar">
                    {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
                    <woot-date-time-picker
                        :value="scheduledAt"
                        :disable-dates="0"
                        :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                        :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                        :type="'time'"
                        :displayFormat="'HH:mm'"
                        :disabled="true"
                    />
                </label>

                <!-- Schedule time date selector -->
                <article v-if="kind === 'call'" class="add_camp_calendar">
                    <label class="field_label">
                        {{ $t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.LABEL') }}
                    </label>
                    <woot-date-time-picker
                        :value="scheduledAt"
                        style="margin-top:'8px'"
                        :disable-dates="0"
                        :confirm-text="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.CONFIRM')"
                        :placeholder="$t('CAMPAIGN.ADD.FORM.SCHEDULED_AT.PLACEHOLDER')"
                        displayFormat="D MMM YYYY HH:mm:ss"
                        :disabled="true"
                    />
                </article>
            </section>
            <section>
                <article>
                    <div class="font_regular text_12 font_500">
                        {{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.TITLE') }}
                    </div>
                    <select
                        v-model="selectedAssistant"
                        class="font_regular text_14 font_500"
                        style="margin-top:8px;"
                        :disabled="true"
                    >
                        <option disabled :value="null">{{ $t('CAMPAIGN.LLM_CHATBOT.AI_BROADCAST_LIST.ADD.ASSISTANT.PLACEHOLDER') }}</option>
                        <option v-for="item in LLMAssistants" :key="item.name" :value="item">{{ item.name }}</option>
                    </select>
                </article>
                <div class="campaint_title_wrap">
                    <woot-input
                        v-model="title"
                        :label="$t('CAMPAIGN.ADD.FORM.TITLE.LABEL')"
                        type="text"
                        class="campaign_title  font_500 text_12"
                        :placeholder="$t('CAMPAIGN.ADD.FORM.TITLE.PLACEHOLDER')"
                        :readonly="true"
                    />
                </div>
            </section>

              <div>

                <woot-button
                    color-scheme="primary"
                    size="small"
                    variant="outline"
                    @click="onSave"
                >
                <!-- :is-loading="uiFlags.isCreating || uiFlags.isUpdating"
                :is-disabled="uiFlags.isCreating || uiFlags.isUpdating" -->
                {{$t('COUPON.ADD_FORM.TYPE_FORM.BTNS.SAVE')}}
                </woot-button>
            </div>
        </div>

    </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import { required, url, minLength, requiredIf } from 'vuelidate/lib/validators';
import Modal from 'dashboard/components/Modal.vue';
import alertMixin from 'shared/mixins/alertMixin';
import campaignMixin from 'shared/mixins/campaignMixin';
import filterMixin from 'shared/mixins/filterMixin';
import { mixin as clickaway } from 'vue-clickaway';
import WootDateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import FilterInputBox from 'components/widgets/FilterInput/Index.vue';
import contactFilterItems, {filterAttributeGroups} from '../../../contacts/contactFilterItems/index';
import countries from '../../../../../../shared/constants/countries';
import * as OPERATORS from '../../../../../components/widgets/FilterInput/FilterOperatorTypes';


export default {
    components: {
        Modal,
        WootDateTimePicker,
        FilterInputBox,
    },
     mixins: [alertMixin, campaignMixin, filterMixin, clickaway],
    props: {
        isOpen: {
            type: Boolean,
            default: false,
        },
        onClose: {
            type: Function,
            default: () => {},
        },
        types:{
            type: Array,
            default: () => ([]),
        },
        kind:{
            type: String,
            default: "",
        },
        prefilappliedFilters:{
            type: Array,
            default: () => ([]),
        },
        scheduledAt:{
            type: Date,
            default: "",
        },
        selectedAssistant:{
            type: Object,
            default: ()=>({})
        },
        title:{
            type: String,
            default: "",
        },
        campaign_repeat_at:{
            type: Object,
            default: ()=>({})
        },
        onGoingOperators:{
            type: Array,
            default: ([])
        },
    },
    data(){
        return {
            appliedFilters: [],
            filterGroups: [],
            filterTypes: contactFilterItems.map(filter => ({
                ...filter,
                attributeName: this.$t(`CONTACTS_FILTER.ATTRIBUTES.${filter.attributeI18nKey}`),
            })),
            filterAttributeGroups,
            attributeModel: 'contact_attribute',
            filtersFori18n: 'CONTACTS_FILTER',
            onGoingDateFilterGroups: [],
        }
    },
    computed:{
        ...mapGetters({
            currentUser: 'getCurrentUser',
            getAppliedContactFilters: 'contacts/getAppliedContactFilters',
            contactStatus: 'accounts/getContactStatus',
            LLMAssistants: 'llmbots/getLLMAssistants',
        }),
    },
    async mounted(){
        this.setInitialStates();
        this.setFilterAttributes();
        // sent contact filters
        if (this.getAppliedContactFilters.length) {
            this.appliedFilters = [...this.getAppliedContactFilters];
        } else {
            this.appliedFilters.push({
                attribute_key: 'name',
                filter_operator: 'equal_to',
                values: '',
                query_operator: 'and',
                attribute_model: 'standard',
            });
        }
    },
    watch: {
        prefilappliedFilters: {
            handler(newVal) {
            this.appliedFilters = [...newVal];
            },
            immediate: true,
            deep: true
        }
    },
     validations(){
        const commonValidations = {
            appliedFilters: {
                required,
                $each: {
                    values: {
                        required: requiredIf(prop=>{
                            return !(prop.filter_operator === 'is_present' || prop.filter_operator === 'is_not_present');
                        }),
                    },
                },
            },
        };

        return {
            ...commonValidations
        }
    },
    methods:{
        async onSave(){
            this.$emit("onSave")
        },
        async setInitialStates (){
            let allCustomAttributes = this.$store.getters['attributes/getAttributesByModel'](this.attributeModel);
            // if (allCustomAttributes.length) {
            //     await this.$store.dispatch('attributes/get');
            // }
            await this.$store.dispatch('attributes/get'); // always set which will updatte this.filterTypes state from mixing
            await this.$nextTick()
            this.setFilterAttributes();

            // call to get 'date' type attribute filter group
            try {
                this.getTimeFilterGroup();
            } catch (error) {
                console.log(error);
            }
        },
        getInputType(key) {
            const type = this.filterTypes.find(filter => filter.attributeKey === key);
            return type.inputType;
        },
        getOperators(key) {
            const type = this.filterTypes.find(filter => filter.attributeKey === key);
            return type.filterOperators;
        },
        getDropdownValues(type) {
            switch (type) {
                case 'country_code':
                return countries;
                case 'status_id':
                return this.contactStatus;
                default:
                return undefined;
            }
        },
        showUserInput(operatorType) {
            return !(operatorType === 'is_present' || operatorType === 'is_not_present');
        },
        resetFilter(index, currentFilter) {
            this.appliedFilters[index].filter_operator = this.filterTypes.find(
                filter => filter.attributeKey === currentFilter.attribute_key
            ).filterOperators[0].value;
            this.appliedFilters[index].values = '';
        },
        removeFilter(index) {
            if (this.appliedFilters.length <= 1) {
                this.showAlert(this.$t('CONTACTS_FILTER.FILTER_DELETE_ERROR'));
            } else {
                this.appliedFilters.splice(index, 1);
            }
        },
        // appendNewFilter() {
        //     this.appliedFilters.push({
        //         attribute_key: 'name',
        //         filter_operator: 'equal_to',
        //         values: '',
        //         query_operator: 'and',
        //     });
        // },
        customAttributeInputType(key) {
            switch (key) {
                case 'date':
                return 'date';
                default:
                return 'plain_text';
            }
        },
        getOperatorTypes(key) {
            switch (key) {
                case 'list':
                    return OPERATORS.OPERATOR_TYPES_1;
                case 'text':
                    return OPERATORS.OPERATOR_TYPES_3;
                case 'number':
                    return OPERATORS.OPERATOR_TYPES_1;
                case 'link':
                    return OPERATORS.OPERATOR_TYPES_1;
                case 'date':
                    return OPERATORS.OPERATOR_TYPES_4;
                case 'checkbox':
                    return OPERATORS.OPERATOR_TYPES_1;
                default:
                    return OPERATORS.OPERATOR_TYPES_1;
            }
        },
        getTimeFilterGroup(){
            let allCustomAttributes = this.$store.getters[
                'attributes/getAttributesByModel'
            ](this.attributeModel);

            const customAttributesFormattedForDate = {
                name: this.$t(`${this.filtersFori18n}.GROUPS.CUSTOM_ATTRIBUTES`),
                attributes: allCustomAttributes.map(attr => {
                return {
                    key: attr.attribute_key,
                    name: attr.attribute_display_name,
                    attribute_display_type: attr.attribute_display_type,
                };
                }).filter(attrDate =>attrDate.attribute_display_type === "date"),
            };

            const filterGroupsDate = [customAttributesFormattedForDate];

            this.onGoingDateFilterGroups = filterGroupsDate;
        },

    },
}
</script>


<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';
.common_font {
    font-family: 'Figtree', sans-serif;
    line-height: 1.4;
    color: #1F1F1F;
}

.campaign_types{
    display: flex;
    justify-content: center;
    gap: 12px;
    list-style: none;
    margin-top: 24px;
}
.campaign_type{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-items: center;
    justify-content: center;
    width: 200px;
    height: 200px;
    border: 1px solid #EEEEEE;
    border-radius: 10px;
    padding: 20px;
    margin: 24px 0 0 0;
    cursor: pointer;
    transition:  all ease-in-out 0.2s;

    .type_body{
        margin-top: 16px;
        text-align: center;
        .name{
            @extend .common_font;
            font-weight: 600;
            font-size: 16px;
            color: #000;
        }
        .description{
            @extend .common_font;
            font-weight: 500;
            font-size: 14px;
            color:#858585;
            margin-top: 4px;
        }
    }
}
.active_type{
    border: 2px solid #8D25F6;
    transition:  all ease-in-out 0.2s;
}
.field_label{
    @extend .common_font;
    font-weight: 500;
    font-size: 12px;
    margin-top: 16px;
    margin-bottom: 8px;
}
.audience_filter{
    margin-bottom: 8px;
}

</style>

<style>
.aiBroadcastPreview input,
.aiBroadcastPreview select{
    background-color: #eee !important;
}

.aiBroadcastPreview input,
.aiBroadcastPreview select,
.aiBroadcastPreview option {
    font-family: 'Figtree', sans-serif !important;
  font-size: 14px !important;
  /* color: #1F1F1F !important; */
  color: #858585 !important;
}
.aiBroadcastPreview .date-picker{
    margin: 0;
}
</style>